<form
  method="get"
  class="form"
  role="search"
  aria-label="Suche"
  action="/suche/"
  data-suggest-api="/api/search/suggest"
  [class.input-inpage]="inpage"
>
  <ng-container *ngIf="viewport === 'mobile'">
    <label class="search-form__label--mobile" for="search-form-header-mobile">
      <hdi-icon [iconName]="'search'" [iconPrefix]="'far'"></hdi-icon>
      <span class="label">{{ label }}</span>
    </label>
  </ng-container>

  <ng-container *ngIf="viewport == 'desktop'">
    <label
      class="search-form__label"
      for="search-form-header-desktop"
      #inputLabel
    >
      <hdi-input
        #inputElement
        [type]="inputType"
        [disabled]="disabled"
        [placeholder]="placeholder"
        [inpage]="inpage"
        [class.input-inpage]="inpage"
        [hasError]="hasError"
        (handleInputChange)="inputChange($event)"
      ></hdi-input>
      <span class="nav__search">
        <hdi-icon
          [color]="hasError ? buttonIconColorError : buttonIconColor"
          [iconName]="'magnifying-glass'"
          [iconPrefix]="'far'"
          (click)="clearInput()"
        ></hdi-icon>
      </span>
      <span class="close__search" *ngIf="showCloseIcon">
        <hdi-icon
          [color]="hasError ? iconColorError : iconColor"
          [iconName]="'circle-xmark'"
          [iconPrefix]="'far'"
          (click)="clearInput()"
        ></hdi-icon>
      </span>
    </label>
  </ng-container>
</form>
